export const PredicateUIType = {
  Selector: 0,
  Editor: 1,
  ReadOnly: 2,
};

export const PredicateType = {
  Number: 'number',
  Integer: 'integer',
  Boolean: 'boolean',
  Category: 'category',
  Selector: 'id',
  String: 'string',
  Custom: 'custom',
  Date: 'datetime',
};

export const PredicateValueUIType = {
  Checkbox: 'checkbox',
  Radio: 'radio',
  Select: 'select',
  Textarea: 'textarea',
};

export const FilterStorageType = {
  SelectableFilter: 'SelectableFilter',
  EditableFilter: 'EditableFilter',
};

export const MaximumPredicateLimit = 10;

export const MaximumSavedFiltersLimit = 10;

export const FilterBarIngoreClickOutsideClassName = 'filter-bar-ignore-click-outside';

export const WaterfallFilterType = {
  CampaignType: 0,
  CampaignStatus: 1,
  AdGroupStatus: 2,
  DateFilter: 3,
};
